<template>
  <div class="go-in">
    <div
      class="introduction"
      id="intro"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <TitleTips
        :routerList="routerList"
        routeType="/humanResource/employmentConcept"
        title="用人理念"
      />
      <div style="display: flex; justify-content: center">
        <div
          style="
            display: flex;
            color: #555;
            align-items: center;
            flex-direction: column;
            margin-bottom: 0.3rem;
          "
        >
          <p
            style="font-size: 0.24rem; font-weight: 700; margin-bottom: 0.3rem"
          >
            {{ talentConcept.name }}
          </p>
          <span
            style="
              margin-bottom: 0.1rem;
              font-size: 0.16rem;
              line-height: 0.32rem;
            "
            >{{ talentConcept.val }}</span
          >
        </div>
      </div>
      <!-- <div
        style="
          box-sizing: border-box;
          padding: 0.4rem 0.7rem 0.1rem 0.7rem;
          background: #f2f2f280;
        "
      >
        <div style="font-size: 0.16rem; color: #555">
          <p
            style="
              font-size: 0.24rem;
              font-weight: 700;
              margin-bottom: 0.3rem;
              text-align: center;
            "
          >
            {{ staffLife.name }}
          </p>
          <span
            style="
              margin-bottom: 0.1rem;
              font-size: 0.16rem;
              line-height: 0.32rem;
            "
            >{{ staffLife.val }}</span
          >
          <el-row :gutter="16">
            <el-col :span="8"
              ><ComponentProduct
                borderRadius="0.1rem"
                width="3rem"
                height="3rem"
                v-if="imgObj.img1"
                :imgUrl="getUrl(imgObj.img1.val)"
                :productName="imgObj.img1.name"
              />
            </el-col>
            <el-col :span="8">
              <ComponentProduct
                borderRadius="0.1rem"
                width="3rem"
                height="3rem"
                v-if="imgObj.img2"
                :imgUrl="getUrl(imgObj.img2.val)"
                :productName="imgObj.img2.name"
              />
            </el-col>
            <el-col :span="8">
              <ComponentProduct
                borderRadius="0.1rem"
                width="3rem"
                height="3rem"
                v-if="imgObj.img3"
                :imgUrl="getUrl(imgObj.img3.val)"
                :productName="imgObj.img3.name"
              />
            </el-col>
          </el-row>
        </div>
      </div>
      <div style="box-sizing: border-box; padding: 0.4rem 0.7rem 0.1rem 0.7rem">
        <div style="font-size: 0.16rem; color: #555">
          <p
            style="
              font-size: 0.24rem;
              font-weight: 700;
              margin-bottom: 0.3rem;
              text-align: center;
            "
          >
            {{ staffCare.name }}
          </p>
          <span
            style="
              margin-bottom: 0.1rem;
              font-size: 0.16rem;
              line-height: 0.32rem;
            "
            >{{ staffCare.val }}</span
          >
          <el-row :gutter="16">
            <el-col :span="8">
              <ComponentProduct
                borderRadius="0.1rem"
                width="3rem"
                height="3rem"
                v-if="imgObj.img4"
                :imgUrl="getUrl(imgObj.img4.val)"
                :productName="imgObj.img4.name"
              />
            </el-col>
            <el-col :span="8">
              <ComponentProduct
                borderRadius="0.1rem"
                width="3rem"
                v-if="imgObj.img5"
                height="3rem"
                :imgUrl="getUrl(imgObj.img5.val)"
                :productName="imgObj.img5.name"
              />
            </el-col>
            <el-col :span="8">
              <ComponentProduct
                borderRadius="0.1rem"
                width="3rem"
                v-if="imgObj.img6"
                height="3rem"
                :imgUrl="getUrl(imgObj.img6.val)"
                :productName="imgObj.img6.name"
              />
            </el-col>
          </el-row>
        </div>
      </div> -->
      <div
        style="
          box-sizing: border-box;
          padding: 0.4rem 0.7rem 0.1rem 0.7rem;
          background: #f2f2f280;
        "
      >
        <div style="font-size: 0.16rem; color: #555">
          <p
            style="
              font-size: 0.24rem;
              font-weight: 700;
              margin-bottom: 0.3rem;
              text-align: center;
            "
          >
            {{ talentDevelopment.name }}
          </p>
          <span
            style="
              margin-bottom: 0.1rem;
              font-size: 0.16rem;
              line-height: 0.32rem;
            "
            >{{ talentDevelopment.val }}</span
          >
          <el-row :gutter="16">
            <el-col :span="8">
              <ComponentProduct
                borderRadius="0.1rem"
                width="3rem"
                v-if="imgObj.img7"
                height="3rem"
                :imgUrl="getUrl(imgObj.img7.val)"
                :productName="imgObj.img7.name"
              />
            </el-col>
            <el-col :span="8"
              ><ComponentProduct
                borderRadius="0.1rem"
                width="3rem"
                v-if="imgObj.img8"
                height="3rem"
                :imgUrl="getUrl(imgObj.img8.val)"
                :productName="imgObj.img8.name"
              />
            </el-col>
            <el-col :span="8">
              <ComponentProduct
                borderRadius="0.1rem"
                width="3rem"
                v-if="imgObj.img9"
                height="3rem"
                :imgUrl="getUrl(imgObj.img9.val)"
                :productName="imgObj.img9.name"
              />
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import ComponentProduct from '../components/ComponentProduct.vue';
import http from '../utils/http';
import getFileUrl from '../utils/urlHelp';
export default {
  components: {
    TitleTips,
    ComponentProduct
  },
  data() {
    return {
      pageLoading: false,
      imgUrlBanner: '',
      pageObj: {},
      routerList: [],
      talentConcept: {}, //人才理念
      staffLife: {}, //员工生活
      staffCare: {}, //员工关爱
      talentDevelopment: {}, //人才发展
      imgObj: {
        img1: '',
        img2: '',
        img3: '',
        img4: '',
        img5: '',
        img6: '',
        img7: '',
        img8: '',
        img9: ''
      }
    };
  },
  created() {
    this.pageLoading = true;
    http
      .post('/reception/recruit/getPage', {
        groupType: '110',
        title: '',
        pageNum: 1,
        pageSize: 100
      })
      .then(res => {
        res.rows.forEach(item => {
          if (item.code === 'talentConcept') {
            this.talentConcept = item;
          } else if (item.code === 'staffLife') {
            this.staffLife = item;
          } else if (item.code === 'staffCare') {
            this.staffCare = item;
          } else if (item.code === 'talentDevelopment') {
            this.talentDevelopment = item;
          } else if (item.code === 'img1') {
            this.imgObj.img1 = item;
          } else if (item.code === 'img2') {
            this.imgObj.img2 = item;
          } else if (item.code === 'img3') {
            this.imgObj.img3 = item;
          } else if (item.code === 'img4') {
            this.imgObj.img4 = item;
          } else if (item.code === 'img5') {
            this.imgObj.img5 = item;
          } else if (item.code === 'img6') {
            this.imgObj.img6 = item;
          } else if (item.code === 'img7') {
            this.imgObj.img7 = item;
          } else if (item.code === 'img8') {
            this.imgObj.img8 = item;
          } else if (item.code === 'img9') {
            this.imgObj.img9 = item;
          }
        });
      })
      .finally(() => {
        this.pageLoading = false;
      });
  },
  mounted() {
    this.routerList = this.$route.matched;
  },
  methods: {
    getUrl(str) {
      return getFileUrl(str);
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  .introduction {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0.5rem 1rem;
  }
}
</style>
